module.exports = __webpack_public_path__ + "img/rot09.5d52cce6.jpg";